import { Tag } from '@chakra-ui/react';

export function CouponAppliedTag({ value }: { value: number }) {
  if (value <= 0 || value > 100) return null;
  return (
    <Tag
      as='b'
      bg='#34835D'
      border='none'
      color='white'
      fontFamily='body'
      fontWeight='600 !important'
      size='sm'
      whiteSpace='nowrap'
    >
      {value}% off
    </Tag>
  );
}
